import { createContext } from 'react'
import { makeUrlStateContext, OrgUnitProviderReportAvailability } from '@percept/hooks'
import {
  DimensionType,
  InsightCategory,
  InsightsReportViewType,
  InsightVertical,
  PlatformUnit,
  ReportEntityPayload,
  ReportPayload,
  ReportProviderV2,
  ReportSeries,
  StructuralReport,
  TimeseriesGranularity,
  UserPrivileges,
} from '@percept/types'

export const UserPrivilegeContext = createContext<UserPrivileges>({} as UserPrivileges)


export type InsightUrlParams = {
  report: string
  verticals?: InsightVertical[] | null
  category?: InsightCategory | null
  insight?: string
  view?: InsightsReportViewType
  metric?: string
  segment?: string
  dimension?: DimensionType
}

export const defaultInsightUrlParams: InsightUrlParams = {
  report: 'latest',
  insight: undefined,
  metric: undefined,
  dimension: undefined,
  segment: undefined,
  verticals: undefined,
  category: undefined,
  view: undefined,
}

export const InsightContext = makeUrlStateContext<InsightUrlParams>()


export const OrgUnitContext = createContext<PlatformUnit>({} as PlatformUnit)
export const NullableOrgUnitContext = createContext<PlatformUnit | null>(null)

export const ReportProviderContext = createContext<ReportProviderV2>('' as ReportProviderV2)

export const ReportSeriesContext = createContext<ReportSeries>({} as ReportSeries)

export const OrgUnitReportAvailabilityContext = createContext<OrgUnitProviderReportAvailability[] | null>(null)

export type DateRangeContextValue = (
  Record<'start' | 'end' | 'minDate' | 'maxDate', Date | null> & {
    granularity?: TimeseriesGranularity
  }
)

export const DateRangeContext = createContext<DateRangeContextValue>({
  start: null,
  end: null,
  minDate: null,
  maxDate: null,
})

export type TimseriesContextValue = DateRangeContextValue & {
  granularity: TimeseriesGranularity
}

export const TimeseriesContext = createContext<TimseriesContextValue>({
  start: null,
  end: null,
  minDate: null,
  maxDate: null,
  granularity: '' as TimeseriesGranularity,
})

export const StructuralReportContext = createContext<StructuralReport>({} as StructuralReport)
export const StructuralReportPayloadContext = createContext<ReportPayload>({} as ReportPayload)
export const StructuralReportEntityPayloadContext = createContext<ReportEntityPayload>({} as ReportEntityPayload)
